<div class="modal-dialog modal-dialog-centered transaction-modal-dialog">
    <div class="modal-content">
        <div class="modal-body">
            <div class="transaction-modal-card" [class.is-success]="isSuccessState" [class.is-failed]="isFailureState">
                <button
                    *ngIf="canClose && !progressData?.hideDefaultCloseButton && !progressData?.showButton"
                    type="button"
                    class="transaction-close"
                    aria-label="Close"
                    (click)="closeModal.emit()">
                    <i class="bi bi-x-lg"></i>
                </button>

                <div class="transaction-status-icon" [class.is-success]="isSuccessState" [class.is-failed]="isFailureState">
                    <ng-container *ngIf="isPendingState">
                        <span class="status-spinner"></span>
                    </ng-container>

                    <i *ngIf="isSuccessState" class="bi bi-check-lg"></i>
                    <i *ngIf="isFailureState" class="bi bi-x-lg"></i>
                </div>

                <h4 class="transaction-title">{{ headerTitle }}</h4>
                <p class="transaction-message" *ngIf="headerMessage" [textContent]="headerMessage"></p>
                <div class="transaction-message" *ngIf="isSuccessState && progressData?.successTitleHtml" [textContent]="progressData?.successTitleHtml"></div>

                <div class="transaction-steps" *ngIf="showSteps">
                    <div class="transaction-step" *ngFor="let step of progressData?.steps">
                        <div class="transaction-step-copy">
                            <h5 [class.is-muted]="step.status === _stepStatus.NOT_INITIATTED">{{ step.title }}</h5>
                            <p *ngIf="step.description" [class.is-muted]="step.status === _stepStatus.NOT_INITIATTED">{{ step.description }}</p>
                        </div>

                        <div class="transaction-step-indicator">
                            <span *ngIf="step.status === _stepStatus.NOT_INITIATTED" class="step-placeholder">---</span>
                            <span *ngIf="step.status === _stepStatus.IN_PROGRESS" class="step-spinner"></span>
                            <i *ngIf="step.status === _stepStatus.COMPLETED" class="bi bi-check-lg step-success"></i>
                            <i *ngIf="step.status === _stepStatus.FAILED" class="bi bi-x-lg step-failed"></i>
                        </div>
                    </div>
                </div>

                <div class="transaction-details" *ngIf="progressData?.details?.length" [class.is-summary]="isSuccessState && !showSteps">
                    <div class="transaction-detail-row" *ngFor="let detail of progressData?.details">
                        <span class="transaction-detail-label">{{ detail.label }}</span>
                        <span class="transaction-detail-value" *ngIf="!detail.isHtml">{{ detail.value }}</span>
                        <span class="transaction-detail-value" *ngIf="detail.isHtml" [textContent]="detail.value"></span>
                    </div>
                </div>

                <div class="transaction-links" *ngIf="progressData?.links?.length">
                    <a
                        *ngFor="let link of progressData?.links"
                        [href]="link.href"
                        [attr.target]="link.external === false ? null : '_blank'"
                        rel="noopener noreferrer">
                        {{ link.label }}
                    </a>
                </div>

                <div class="transaction-footer" *ngIf="footerText">
                    <span [class.is-timer]="isFooterTimer">{{ footerText }}</span>
                </div>

                <div class="transaction-actions" *ngIf="canClose && (progressData?.primaryActionLabel || progressData?.secondaryActionLabel || !progressData?.hideDefaultCloseButton)">
                    <button
                        *ngIf="progressData?.secondaryActionLabel"
                        type="button"
                        class="transaction-btn transaction-btn-secondary"
                        (click)="secondaryAction.emit()">
                        {{ progressData?.secondaryActionLabel }}
                    </button>

                    <button
                        *ngIf="progressData?.primaryActionLabel"
                        type="button"
                        class="transaction-btn transaction-btn-primary"
                        (click)="primaryAction.emit()">
                        {{ progressData?.primaryActionLabel }}
                    </button>

                    <button
                        *ngIf="!progressData?.primaryActionLabel && !progressData?.secondaryActionLabel && !progressData?.hideDefaultCloseButton"
                        type="button"
                        class="transaction-btn transaction-btn-primary"
                        (click)="closeModal.emit()">
                        Close.
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
